import Search from "antd/es/input/Search";
import React, { useState } from "react";

interface SearchProps {
  handleSearch?: (value: string) => void;
  className?: string
  placeholder?: string
  searchText?: string
}

const SearchComponent = React.memo(({ handleSearch, className, placeholder, searchText }: SearchProps) => {
  
  const onSearch = async (value: any) => {
   handleSearch && handleSearch(value);
  };

  return (
    <Search onSearch={onSearch} allowClear defaultValue={searchText} className={className} style={{ maxWidth: 300 }} placeholder={placeholder} />
  );
}, (prevProps, nextProps) => {
  return (
    prevProps.handleSearch === nextProps.handleSearch &&
    prevProps.className === nextProps.className &&
    prevProps.placeholder === nextProps.placeholder
  );
});

export default SearchComponent